module.exports = __webpack_public_path__ + "img/hr-construction-robot-working.3e97f918.png";